import React, { useCallback, useEffect, useState } from 'react';
import { NameIdObj } from 'common/models/GenericTypes';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import MultipleUserPicker from 'components/Pickers/MultipleUserPicker';
import MultipleGroupPicker from 'components/Pickers/MultipleGroupPicker';
import { Dashboard } from 'common/models/Dashboard/Dashboard';
interface Props {
  open: boolean;
  data?: Dashboard | null;
  shareDashboardHandler?: (id: number, selectedUserIds: string, selectedGroupIds: string) => void;
  closeDialogHandler: () => void;
}

export default function ShareDashboardDialog({
  open,
  data,
  shareDashboardHandler,
  closeDialogHandler,
}: Props) {
  const [selectedUsers, setSelectedUsers] = useState<number[]>([]);
  const [selectedGroups, setSelectedGroups] = useState<number[]>([]);

  useEffect(() => {
    if (data) {
      setSelectedUsers(data.sharedUserIds.split(',').map(Number));
      setSelectedGroups(data.sharedGroupIds.split(',').map(Number));
    }
  }, [data]);

  const shareDashboard = useCallback(async () => {
    if (data) {
      shareDashboardHandler &&
        shareDashboardHandler(data?.id, selectedUsers.join(','), selectedGroups.join(','));
    }
  }, [shareDashboardHandler, selectedUsers, selectedGroups, data]);

  const onNumericValuesChange = useCallback((values: NameIdObj[], type: string) => {
    const ids = values.map((v) => v.id);
    if (type == 'users') {
      setSelectedUsers(ids);
    }

    if (type == 'groups') {
      setSelectedGroups(ids);
    }
  }, []);

  return (
    <Dialog fullWidth open={open}>
      <DialogTitle>Share Dashboard {data?.name}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt="10px">
          <MultipleUserPicker
            value={selectedUsers}
            onSelect={(s) => {
              onNumericValuesChange(s, 'users');
            }}
            label="Users"
          />
          <MultipleGroupPicker
            value={selectedGroups}
            onSelect={(s) => {
              onNumericValuesChange(s, 'groups');
            }}
            label="Groups"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" onClick={closeDialogHandler}>
          Cancel
        </Button>
        <Button variant="contained" color="success" onClick={shareDashboard}>
          Share
        </Button>
      </DialogActions>
    </Dialog>
  );
}
